import { Pool } from '../../../../../../apis/pool.api';
import { IProduct } from '../../../IProduct';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P00043InstallationReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.PAC_Control,
    'paCResetUsine',
    1,
    null,
    productClass,
  );
}
